import React from 'react';
import { AlertMessage } from '@brighterion/br-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { hideNetworkBanner, showNetworkBanner } from 'Store';

import useIsOnline from 'Hooks/useIsOnline';
import { getShowNetworkBanner } from 'Selectors';

function NoNetworkBanner() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const show = useSelector(getShowNetworkBanner);

    // similar to react-table, we require the caller to memoize the options
    useIsOnline({
        onOnline: React.useCallback(() => {
            dispatch(hideNetworkBanner());
        }, [dispatch]),
        onOffline: React.useCallback(() => {
            dispatch(showNetworkBanner());
        }, [dispatch])
    });

    if (!show) return null;

    return (
        <div>
            <AlertMessage
                dataTestId='no-network-banner'
                isOpen
                type='danger'
                closeAlert={() => dispatch(hideNetworkBanner())}
            >
                {t('noNetworkErrorMsg')}
            </AlertMessage>
        </div>
    );
}

export default NoNetworkBanner;
